import { DonorAction } from './donor-action';

export const menuItemList = [
    { action: DonorAction.Edit, title: 'Edit' },
    { action: DonorAction.Remove, title: 'Remove' },
    { action: -1, title: '' }
];